// ════════════════════════════════════════════════════════════════════════
//  Prüfung auf unfertige Redaktion
//
//  Gehört bewusst NICHT nach packages/lehrgang: `checkBundle` ist die
//  gemeinsame Wahrheit von Lern-App und Admin, und ein Platzhaltertext ist kein
//  ungültiges Bundle. Die Lern-App darf an einer veröffentlichten Fassung nicht
//  scheitern, nur weil ein Untertitel schwach ist – sie hätte dann einen Grund
//  weniger, überhaupt zu starten.
//
//  Hier sperrt derselbe Befund das Veröffentlichen. Der Anlass: eine mit
//  „Lektion anhängen“ erzeugte Lektion war sofort GÜLTIG – Platzhalter in jedem
//  Feld, kein einziger Hinweis, veröffentlichbar. Der Fehler fiel erst im
//  Klassenzimmer auf.
// ════════════════════════════════════════════════════════════════════════

import type { Bundle, Problem } from "@otto/lehrgang";

/** Was die Oberfläche selbst einsetzt, wenn sie etwas Neues anlegt. */
const PLACEHOLDERS = {
  lessonTitle: /^Lektion \d+$/,
  subtitle: "Untertitel",
  intro: "Einleitung für die Kinder",
  stageTitle: /^(Stufe \d+|Neue Stufe)$/,
  hint: "Hinweis für die Kinder",
} as const;

/**
 * Stehengebliebene Platzhalter.
 *
 * Geprüft wird auf Gleichheit, nicht auf Ähnlichkeit: „Untertitel“ als ganzer
 * Untertitel ist ein Platzhalter, das Wort in einem Satz ist keiner. Eine
 * unscharfe Prüfung sperrte hier das Veröffentlichen wegen einer Formulierung.
 */
export function checkEditorial(bundle: Bundle): Problem[] {
  const problems: Problem[] = [];

  for (const lesson of bundle.lessons) {
    const at = `lessons.${lesson.key}`;
    if (PLACEHOLDERS.lessonTitle.test(lesson.title)) {
      problems.push({ path: at, message: `Lektion heißt noch "${lesson.title}"` });
    }
    if (lesson.subtitle === PLACEHOLDERS.subtitle) {
      problems.push({ path: at, message: "Untertitel ist noch der Platzhalter" });
    }
    if (lesson.intro === PLACEHOLDERS.intro) {
      problems.push({ path: at, message: "Einleitung ist noch der Platzhalter" });
    }

    for (const stage of lesson.stages) {
      const stageAt = `${at}.${stage.key}`;
      if (PLACEHOLDERS.stageTitle.test(stage.title)) {
        problems.push({ path: stageAt, message: `Stufe heißt noch "${stage.title}"` });
      }
      if (stage.hint === PLACEHOLDERS.hint) {
        problems.push({ path: stageAt, message: "Hinweis ist noch der Platzhalter" });
      }
    }
  }

  return problems;
}
